import {Grid} from '@primer/react-brand/esm'

import type {GenericSectionWithIds} from '../../../brand/lib/types/contentful'
import {BrandPage, usePage} from '../../../brand/components/BrandPage'

import {HeroSection} from './_sections/HeroSection/HeroSection'
import {OrganizationSection} from './_sections/OrganizationSection/OrganizationSection'
import {PricingSection} from './_sections/PricingSection/PricingSection'
import {ResourcesSection} from './_sections/ResourcesSection/ResourcesSection'
import {WorkflowSection} from './_sections/WorkflowSection/WorkflowSection'

import {PlanTypeContextProvider} from './_context/PlanTypeContext'

import styles from './styles.module.css'

function PageContent() {
  const page = usePage()

  const {
    featuresCopilotHeroSection,
    featuresCopilotOrganizationSection,
    featuresCopilotPricingSection,
    featuresCopilotResourcesSection,
    featuresCopilotWorkflowSection,
  } = page.ids as {
    featuresCopilotHeroSection: GenericSectionWithIds
    featuresCopilotOrganizationSection: GenericSectionWithIds
    featuresCopilotPricingSection: GenericSectionWithIds
    featuresCopilotResourcesSection: GenericSectionWithIds
    featuresCopilotWorkflowSection: GenericSectionWithIds
  }

  return (
    <PlanTypeContextProvider>
      <Grid>
        <Grid.Column span={12}>
          {featuresCopilotHeroSection ? <HeroSection contentfulContent={featuresCopilotHeroSection} /> : null}

          {featuresCopilotWorkflowSection ? (
            <WorkflowSection contentfulContent={featuresCopilotWorkflowSection} />
          ) : null}

          {featuresCopilotOrganizationSection ? (
            <OrganizationSection contentfulContent={featuresCopilotOrganizationSection} />
          ) : null}

          {featuresCopilotPricingSection ? <PricingSection contentfulContent={featuresCopilotPricingSection} /> : null}

          {featuresCopilotResourcesSection ? (
            <ResourcesSection contentfulContent={featuresCopilotResourcesSection} />
          ) : null}
        </Grid.Column>
      </Grid>
    </PlanTypeContextProvider>
  )
}

export default function FeaturesCopilotIndex() {
  return (
    <BrandPage pageClassName={styles.page} subnavClassName={styles.subnav}>
      <PageContent />
    </BrandPage>
  )
}
